import React from "react";
import { Modal, Result, Card, Tag, Typography, Divider, Button } from "antd";
import { WarningOutlined, DeleteOutlined } from "@ant-design/icons";

const InactiveGatewayModal = ({
  isVisible,
  message,
  inactiveGatewayGroups,
  handleRemoveInactiveNumbers,
  handleClose,
}) => {
  return (
    <Modal
      open={isVisible}
      footer={null}
      closable={false}
      width={560}
      centered
      onCancel={handleClose}
    >
      <Result
        status="warning"
        title={
          <Typography.Title level={5} style={{ marginBottom: 0 }}>
            Gateway Not Active
          </Typography.Title>
        }
        subTitle={message}
        style={{ padding: "12px 0" }}
        icon={<WarningOutlined style={{ fontSize: "35px" }} />}
      />

      {(inactiveGatewayGroups || []).map((group) => (
        <Card
          key={group.iso2}
          size="small"
          style={{ marginBottom: 12 }}
          title={
            <span className="h5">
              {group.flag ? `${group.flag} ` : ""}
              {group.name} ({group.numbers?.length || 0})
            </span>
          }
          bodyStyle={{ maxHeight: 160, overflow: "auto" }}
        >
          {(group.numbers || []).map((num) => (
            <Tag
              onClick={() => {
                navigator.clipboard.writeText(num)
                message.success('Copied!')
              }}
              style={{ cursor: 'pointer' }}
            >
              {num}
            </Tag>
          ))}
        </Card>
      ))}

      <Divider style={{ margin: "16px 0" }} />

      <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
        <Button onClick={handleClose}>Close</Button>
        <Button
          type="primary"
          danger
          icon={<DeleteOutlined />}
          onClick={handleRemoveInactiveNumbers}
        >
          Remove Numbers
        </Button>
      </div>
    </Modal>
  );
};

export default InactiveGatewayModal;
